import CryptoJS from 'crypto-js';

const encKey = "ArenaRobotics"

const encrypt = (data: string): string => {
    const encryptedData = CryptoJS.AES.encrypt(data, encKey)
    return encryptedData.toString()
}

const decrypt = (encryptedData: string): string => {
    const data = CryptoJS.AES.decrypt(encryptedData, encKey)
    return data.toString(CryptoJS.enc.Utf8)
}

export { encrypt, decrypt }